import { CLAN_LEAVE_TOGGLE_FETCHING, SELECT_COMMANDER, SET_INITITAL_STATE } from "../Actions/ActionClanLeave";

const initialState = {
  newCommanderId: 0,
  isFetching: false
};

export const clanLeave = (state = initialState, action) => {
  switch (action.type) {
    case CLAN_LEAVE_TOGGLE_FETCHING:
      return Object.assign({}, state, {
        isFetching: !state.isFetching
      });
    case SELECT_COMMANDER:
      return Object.assign({}, state, {
        newCommanderId: action.newCommanderId
      });
    case SET_INITITAL_STATE:
      return Object.assign({}, initialState);
    default:
      return state;

  }
};